import { tw } from '@/utils/tw';
import BaseMorePagesTitleTheme from 'base/components/MorePagesTitle/theme';

const MorePagesTitle = tw.theme({
  extend: BaseMorePagesTitleTheme,
  base: `mx-auto mb-3 mt-9 flex w-full items-center gap-3 px-4 text-headline-3xs after:h-[10px] after:flex-grow after:bg-primary-700 lg:w-2/3`,
});

export default MorePagesTitle;
